// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"c4c54e72","186":"7a5366ab","459":"7dadffcf"}[chunkId] + ".chunk.js";
};